import { useQuery } from '@tanstack/react-query'
import { getNearby } from '../api/nearby'
import type { GeoPosition } from './useGeolocation'

export const nearbyKeys = {
  byCoords: (tripId: string, lat: number, lng: number) =>
    ['nearby', tripId, lat.toFixed(4), lng.toFixed(4)] as const,
}

/** Poll nearest trip point for the user's current coordinates. */
export function useNearby(tripId: string | undefined, position: GeoPosition | null, enabled = true) {
  return useQuery({
    queryKey: nearbyKeys.byCoords(tripId ?? 'unknown', position?.lat ?? 0, position?.lng ?? 0),
    queryFn: () => getNearby(tripId as string, position!.lat, position!.lng),
    enabled: Boolean(enabled && tripId && position),
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
